import { withInstall } from '@vuesax-plus/utils'
import SidebarGroup from './src/sidebar-group.vue'

export const VsSidebarGroup = withInstall(SidebarGroup)
export default VsSidebarGroup

export * from './src/sidebar-group'
